var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikeThroughIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 5.68555C6.33301 5.99592 6.4165 6.26726 6.60206 6.5H5.16706C5.10061 6.26564 5.06836 6.01248 5.06836 5.74023C5.06836 4.11328 6.50391 2.97168 8.54785 2.97168C10.5166 2.97168 11.9385 4.14746 11.9932 5.82227H10.7627C10.6533 4.74219 9.79883 4.0791 8.51367 4.0791C7.2832 4.0791 6.33301 4.68066 6.33301 5.68555Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52734 13.1641C6.37402 13.1641 4.93848 12.0566 4.82227 10.3545H6.05273C6.19629 11.4141 7.18066 12.0566 8.5957 12.0566C9.93555 12.0566 10.9062 11.3525 10.9062 10.3818C10.9062 9.55469 10.3594 9.00781 8.99219 8.70703L8.04576 8.5H1V7.5H15V8.5H11.4958C11.9642 8.93739 12.1709 9.49439 12.1709 10.1973C12.1709 12.0225 10.7354 13.1641 8.52734 13.1641Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeThroughIcon);
export default __webpack_public_path__ + "static/media/strikeThroughIcon.afc092c3eb2b81016f3743eaf686f474.svg";
export { ForwardRef as ReactComponent };